import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Redirect } from 'react-router-dom';

import { checkSession, logout, isLoading } from '../actions';

class LoginRedirect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      sessionGUID: '',
      enterpriseGUID: '',
    };
    this.getPath = this.getPath.bind(this);
  }

  componentWillMount() {
    const { checkSession, location } = this.props;
    let sessionGUID     = null;
    let enterpriseGUID  = null;
    let loggedOut       = null
    if (location.search) {
      sessionGUID     = location.search.split('S=')[1] ? location.search.split('S=')[1].split('&')[0] : null;
      enterpriseGUID  = location.search.split('E=')[1] ? location.search.split('E=')[1].split('&')[0] : null;
      loggedOut       = location.search.split('loggedOut=')[1] ? location.search.split('loggedOut=')[1].split('&')[0] : null;
    }
    if (enterpriseGUID && !loggedOut) {
      this.props.logout();
      this.setState({
        redirect: true,
        sessionGUID,
        enterpriseGUID,
      });
    } else {
      checkSession(sessionGUID, enterpriseGUID);
    }
  }

  getPath() {
    return this.props.loggedIn.isLoggedIn ? '/home' : '/login';
  }

  render() {
    if (this.state.redirect) {
      this.props.isLoading(true);
      setTimeout(() => window.location = `/?S=${this.state.sessionGUID}&E=${this.state.enterpriseGUID}&loggedOut=true`, 500);
      return null;
    }
    return <Redirect to={this.getPath()} />;
  }
}

export default withRouter (connect(
  state => state,
  { checkSession, logout, isLoading }
)(LoginRedirect));



// WEBPACK FOOTER //
// ./src/containers/LoginRedirect.js